var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticStyle: { overflow: "hidden" } },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "", dense: "", color: "secondary", dark: "" } },
        [
          _c("v-toolbar-title", { staticClass: "body-2" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.dateRangeEditable
            ? _c(
                "v-btn-toggle",
                {
                  staticClass: "date-range-toggle",
                  attrs: { mandatory: "" },
                  on: { change: _vm.onDateRangeChange },
                  model: {
                    value: _vm.selectedDateRange,
                    callback: function ($$v) {
                      _vm.selectedDateRange = $$v
                    },
                    expression: "selectedDateRange",
                  },
                },
                _vm._l(_vm.dateRangeShortcuts, function (item, idx) {
                  return _c(
                    "v-btn",
                    {
                      key: idx,
                      staticClass: "text-capitalize",
                      attrs: {
                        flat: "",
                        small: "",
                        value: item.value,
                        title: item.label,
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(item.shortLabel) + "\n      "
                      ),
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading
        ? _c("v-progress-linear", {
            staticClass: "my-0",
            attrs: { indeterminate: "", color: "blue" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c(
            "v-alert",
            {
              staticClass: "py-1 ma-0",
              attrs: {
                outline: "",
                color: "warning",
                icon: "assessment",
                value: true,
              },
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.errorMessage)),
              ]),
            ]
          )
        : _vm.dataForGraph.length > 0
        ? _c(
            "div",
            [
              _vm.dataForGraph[0].length > 0
                ? _c(
                    "v-layout",
                    [
                      _c("v-flex", { attrs: { xs12: "", lg12: "" } }, [
                        _c("h3", { staticClass: "pa-2" }, [
                          _vm._v("Exceedance Data"),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataForGraph[0], function (analyteData) {
                return _c(
                  "v-layout",
                  { key: _vm.loadId + "-ex-" + analyteData.Analyte },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs6: "", lg6: "" } },
                      [
                        _c("FortisDashboardGraph", {
                          attrs: {
                            analyte: analyteData.Analyte,
                            "location-type": "BC Rail Site",
                            datasets: _vm.datasetsFor(
                              analyteData,
                              "BC Rail Site"
                            ),
                            "query-date-range": _vm.dateRange,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs6: "", lg6: "" } },
                      [
                        _c("FortisDashboardGraph", {
                          attrs: {
                            analyte: analyteData.Analyte,
                            "location-type": "Woodfibre LNG Site",
                            datasets: _vm.datasetsFor(
                              analyteData,
                              "Woodfibre LNG Site"
                            ),
                            "query-date-range": _vm.dateRange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.dataForGraph[1].length > 0
                ? _c(
                    "v-layout",
                    [
                      _c("v-flex", { attrs: { xs12: "", lg12: "" } }, [
                        _c("h3", { staticClass: "pa-2" }, [
                          _vm._v("Analyte Data"),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataForGraph[1], function (analyteData) {
                return _c(
                  "v-layout",
                  { key: _vm.loadId + "-an-" + analyteData.Analyte },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs6: "", lg6: "" } },
                      [
                        _c("FortisDashboardGraph", {
                          attrs: {
                            analyte: analyteData.Analyte,
                            "location-type": "BC Rail Site",
                            datasets: _vm.datasetsFor(
                              analyteData,
                              "BC Rail Site"
                            ),
                            "query-date-range": _vm.dateRange,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs6: "", lg6: "" } },
                      [
                        _c("FortisDashboardGraph", {
                          attrs: {
                            analyte: analyteData.Analyte,
                            "location-type": "Woodfibre LNG Site",
                            datasets: _vm.datasetsFor(
                              analyteData,
                              "Woodfibre LNG Site"
                            ),
                            "query-date-range": _vm.dateRange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }